import {
  getSceneResponsiveLayout,
  type LogicalBounds,
  type ResponsiveLayoutConfig,
} from '../../../shared/layout/index.js';

export const CHALLENGE_LAYOUT_WIDTH = 1280;
export const CHALLENGE_LAYOUT_HEIGHT = 720;
export const COMPACT_VIEWPORT_HEIGHT = 700;
export const COMPACT_SAFE_HEIGHT = 690;

export type ChallengeSafeBounds = LogicalBounds;

const CHALLENGE_RESPONSIVE_LAYOUT: ResponsiveLayoutConfig = {
  logicalSize: { width: CHALLENGE_LAYOUT_WIDTH, height: CHALLENGE_LAYOUT_HEIGHT },
  visibilityScaleMode: 'envelop',
  safeInsets: { left: 12, right: 12 },
  compactViewportHeight: COMPACT_VIEWPORT_HEIGHT,
  compactVisibleHeight: COMPACT_SAFE_HEIGHT,
};

export function calculateChallengeSafeBounds(scene: Phaser.Scene): ChallengeSafeBounds {
  return getSceneResponsiveLayout(scene, CHALLENGE_RESPONSIVE_LAYOUT).safe;
}

export function isCompactChallengeLayout(scene: Phaser.Scene, safe: ChallengeSafeBounds) {
  void safe;
  return getSceneResponsiveLayout(scene, CHALLENGE_RESPONSIVE_LAYOUT).compact;
}
